import { useSelector } from "react-redux";
import { isEmpty } from "../utils/helpers";
import useQuery from "./useQuery";

const useWarehouse = () => {
  const authState = useSelector(state => state.jazasoft.auth);

  const { data: whData = [], loading } = useQuery({ url: "warehouses", params: { size: 1000 } });
  const userWhCodes = !isEmpty(authState?.warehouseId) ? authState.warehouseId : whData.map(u => u.code);
  const whList = whData.filter(e => userWhCodes.includes(e.code));
  const whChoices = whList.map(e => ({ id: e.code, name: e.name }));

  return { allWhList: whData, whList, whChoices, userWhCodes, whLoading: loading };
};

export default useWarehouse;
